import { httpClient } from '@/infra/protocols/http';
import { IPodcastDTO } from '@/modules/podcasts/dtos/podcast.dto';
import { IPodcast } from '@/modules/podcasts/entities/podcast.entity';
import { PodcastMapper } from '@/modules/podcasts/mappers/podcast.mapper';

export async function createPodcast(
  params: CreatePodcastService.Params,
  data: CreatePodcastService.Payload,
): Promise<CreatePodcastService.Response> {
  const body = {
    nome: data.name,
    imagem: data.fileName,
    descricao: data.description,
    idPodcastParaAssociacaoBackstage: data.publicationId,
  };

  const response = await httpClient.post<IPodcastDTO>(
    `/v1/projetos/${params.projectId}/podcasts`,
    body,
  );
  return PodcastMapper.toPresentation(response);
}

export namespace CreatePodcastService {
  export interface Params {
    projectId: string;
  }

  export interface Payload {
    name: string;
    fileName?: string;
    description: string;
    publicationId?: string;
  }

  export type Response = IPodcast;
}
